import { render, staticRenderFns } from "./TeachingPhotos.vue?vue&type=template&id=5e2b77c2&scoped=true&"
import script from "./TeachingPhotos.vue?vue&type=script&lang=js&"
export * from "./TeachingPhotos.vue?vue&type=script&lang=js&"
import style0 from "./TeachingPhotos.vue?vue&type=style&index=0&id=5e2b77c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b77c2",
  null
  
)

export default component.exports